import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Layers, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";

export default function CategoriesPage() {
  const [cats, setCats] = useState([]);
  const [streams, setStreams] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/discover/categories").then((r) => setCats(r.data)).catch(() => {});
    api.get("/discover/streams").then((r) => setStreams(r.data)).catch(() => {});
  }, []);

  const streamsByGame = streams.reduce((acc, s) => {
    (acc[s.game] = acc[s.game] || []).push(s);
    return acc;
  }, {});

  const filtered = cats.filter((c) => !q || c.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <main className="flex-1 min-w-0 overflow-y-auto scrollbar-thin" data-testid="categories-page">
      <section className="relative border-b border-[hsl(var(--nx-border))] overflow-hidden">
        <div className="absolute inset-0 nx-grid-bg opacity-40 pointer-events-none" />
        <div className="relative px-6 lg:px-10 py-10 max-w-6xl">
          <div className="nx-chip nx-chip-cyan mb-3"><Layers className="w-3.5 h-3.5" /> Categorias</div>
          <h1 className="font-display font-bold text-3xl sm:text-4xl">Navegue por interesse.</h1>
          <p className="mt-2 text-muted-foreground max-w-xl">Explore o que está bombando em cada categoria.</p>

          <div className="mt-6 relative max-w-lg">
            <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input placeholder="Buscar categoria" value={q} onChange={(e) => setQ(e.target.value)}
              className="pl-10 h-11 rounded-xl bg-[hsl(var(--input))] border-[hsl(var(--nx-border))]"
              data-testid="categories-search" />
          </div>
        </div>
      </section>

      <section className="px-6 lg:px-10 py-10 max-w-6xl">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {filtered.map((c) => (
            <div key={c.id} data-testid={`categories-card-${c.id}`} className="group nx-panel overflow-hidden hover:border-[hsl(var(--nx-cyan))] transition-colors cursor-pointer">
              <div className="aspect-[3/4] overflow-hidden relative">
                <img src={c.cover} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                <div className="absolute top-2 left-2 nx-chip nx-chip-red !py-0.5 !px-1.5 !text-[9px]">{c.viewers > 5000 ? "ALTA" : "MÉDIA"}</div>
                <div className="absolute bottom-2 left-2 right-2">
                  <div className="text-white text-sm font-semibold truncate">{c.name}</div>
                  <div className="text-white/70 text-[10px]">{c.viewers.toLocaleString("pt-BR")} assistindo</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Streams grouped by game */}
        {Object.entries(streamsByGame).map(([game, list]) => (
          <div key={game} className="mt-12">
            <div className="flex items-end justify-between mb-4">
              <h2 className="font-display font-bold text-xl">{game}</h2>
              <span className="text-xs text-muted-foreground">{list.length} lives</span>
            </div>
            <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
              {list.slice(0,3).map((s) => (
                <Link key={s.id} to={`/app/live/${s.id}`} data-testid={`categories-stream-${s.id}`}
                  className="group block nx-panel overflow-hidden hover:border-[hsl(var(--nx-blue))] transition-colors">
                  <div className="relative aspect-video overflow-hidden">
                    <img src={s.thumbnail} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                    <div className="absolute top-2.5 left-2.5 nx-chip nx-chip-red !py-1 !px-2"><span className="nx-live-dot" style={{background:'#fff'}} /> AO VIVO</div>
                    <div className="absolute top-2.5 right-2.5 nx-chip !py-1 !px-2">{s.viewers.toLocaleString("pt-BR")}</div>
                    <div className="absolute bottom-2.5 left-2.5 right-2.5">
                      <div className="text-white font-semibold text-sm truncate">{s.title}</div>
                      <div className="text-white/70 text-[11px] truncate">@{s.creator}</div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </section>
    </main>
  );
}
